interface AccessDeniedPageProps {
  signedInEmail: string | null;
  contactEmail: string;
  onSignOut: () => void;
}

export function AccessDeniedPage({
  signedInEmail,
  contactEmail,
  onSignOut,
}: AccessDeniedPageProps) {
  return (
    <div className="min-h-screen bg-[#fafaf7] flex items-center justify-center p-6">
      <div className="max-w-sm w-full text-center">
        <div className="text-xs font-bold tracking-widest text-rwb-red mb-2">TEAM RWB</div>
        <h1 className="text-2xl font-semibold text-zinc-900 mb-2">Access denied</h1>
        <p className="text-sm text-zinc-500 mb-2">
          Your email isn't on the tester list.
        </p>
        {signedInEmail && (
          <p className="text-xs text-zinc-400 mb-6 font-mono">{signedInEmail}</p>
        )}

        <div className="rounded-lg bg-rose-50 border border-rose-200 p-4 text-left">
          <p className="text-xs text-rose-900 leading-relaxed">
            Reach out to <strong className="font-semibold">{contactEmail}</strong> if you
            believe this is an error or would like to be added to the testing roster.
          </p>
        </div>

        <button
          onClick={onSignOut}
          className="mt-6 text-xs text-zinc-500 hover:text-zinc-800 transition"
        >
          Sign out and try a different account
        </button>
      </div>
    </div>
  );
}
